// src/components/Leaderboard.jsx
import React from "react";
import { Link } from "react-router-dom";
import { companiesData } from "../data/companiesData";

const Leaderboard = () => {
  return (
    <div style={{ padding: 20 }}>


      <table className="table">
        <thead>
          <tr>   
            {/* <th>Id</th> */}
              <th>Rank</th>
            <th>Company</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          {companiesData.map((c) => (
            <tr key={c.id}>
                {/* <td style={{ textAlign: "center" }}>{c.id}</td> */}
                 <td style={{ textAlign: "center" }}>{c.rank}</td>
              <td>
                <Link to={`/company/${c.id}`} className="company-link">
                  {c.name}
                </Link>
              </td>
              <td style={{ textAlign: "center" }}>{c.AverageScoresofEachCompany}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Leaderboard;
